import ZoomInMapOutlined from '@mui/icons-material/ZoomInMapOutlined';
import { Stack, Typography } from '@mui/material';

/**
 * Hover hint shown on a pin that's part of a collapsed spiderfy cluster. The
 * pin's own info popover is suppressed while clustered, so this tells the user
 * how to reveal the individual visits underneath.
 */
export const MapClusterHint = ({ count }: { count: number }) => (
    <Stack direction='row' spacing={1} alignItems='center'>
        <ZoomInMapOutlined fontSize='small' sx={{ color: 'text.secondary' }} />
        <Typography variant='body2'>Click to expand {count} visits in this area</Typography>
    </Stack>
);
